import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminSettings = lazy(() => import("@/pages/admin/AdminSettings"));

export const Route = createFileRoute("/admin/installningar")({
  component: () => <AdminSettings />,
});
